import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { reduxForm, SubmissionError, Form, change } from 'redux-form';
import { Radio } from 'semantic-ui-react';
import { fixCurrency } from 'appSrc/utils';
import { PrimaryButton } from 'appSrc/components/UI';
import TagEditor from 'appSrc/components/Tag/Editor';
import style from './styles/style.module.css';

import AspectRatio from 'react-aspect-ratio';
import ImageCropDiv from 'appSrc/components/ImageUpload/CropDiv';
import ImageCropModalWrapper from 'appSrc/components/ImageUpload/CropModalWrapper';
import ProductFields from 'appSrc/components/Product/ProductFields';
import Carousel from 'appSrc/components/Carousel';
import editIcon from 'appSrc/assets/img/edit_filled.svg';

class DetailsForm extends PureComponent {
    constructor( props ) {
        super( props );

        var imageArr = this.props.product.imageArr || [];
        this.state = {
            selectedImage: imageArr[0] || this.props.product.image || '',
            usingCarousel: this.props.type == 'new',
            deleteConfirm: false,
            mounted: false,
        };
    }
    componentDidMount() {
        this.setState( { mounted: true } );
    }
    redraw = () => {
        this.forceUpdate();
    }
    submit = (values) => {
        const hasOwnProperty = Object.prototype.hasOwnProperty;
        function isEmpty(obj) {
            if (obj == null) return true;
            if (obj.length > 0)    return false;
            if (obj.length === 0)  return true;
            if (typeof obj !== 'object') return true;
            for (var key in obj) {
                if (hasOwnProperty.call(obj, key)) return false;
            }
            return true;
        }

        var title = ( !!values.title ) ? values.title.trim() : '';
        if( isEmpty( values ) ) {
            //no input
            throw new SubmissionError( { title: 'Name required' } );
        } else if( title === '' ) {
            throw new SubmissionError({ title: 'Name required' });
        } else if( !this.state.selectedImage ) {
            throw new SubmissionError( { image: 'Image required' } );
        } else if( !values.price ) {
            throw new SubmissionError( { price: 'Please enter a value' } );
        }

        if( this.props.showLists ) {
            if( !values.listid ) {
                throw new SubmissionError( { listid: 'Please choose a list' } );
            }
        }

        // Tag handling... it's more complicated than it really needs to be
        var tagObjects = this.tagEditor.getTags();

        var price = fixCurrency( values.price ).replace( ',', '' );

        var data = {
            ...values,
            price: price,
            tagObjects: tagObjects,
        };
        //add cropped image dataUrl
        if( this.state.usingCarousel && data.imageArr.length > 0 ) {
            var cropData = this._cropWrapper.getCropData();
            if( !cropData.error ) {
                data.image = this.state.selectedImage;
                delete data.imageArr;
                data.cropping = cropData;
                this.props.nextStep( data );
            } else {
                //TODO: throw an error
            }
        } else {
            data.image = this.state.selectedImage;
            delete data.imageArr;
            this.props.nextStep( data );
        }
    }
    selectCarouselImage = ( image ) => {
        this.setState( { selectedImage: image, usingCarousel: true } );
        this._cropWrapper.changedImage();
    }
    cropFinish = ( imageData ) => {
        this.setState( {
            selectedImage: imageData,
            usingCarousel: false,
        } );
        if( imageData != null ) {
            if( this._cropWrapper ) {
                this._cropWrapper.changedImage();
            }
            this.props.changeFieldValue( 'image', imageData );
        }
    }

    renderImageOptionsCarousel = () => {
        if( this.props.type == 'edit' || this.props.type == 'copy' ) {
            return null;
        }
        var sliderProps = { sliderSettings: { slidesToShow: 3, slidesToScroll: 3, responsive: false } };
        var imageArr = [];
        if( this.props.product ) {
            imageArr = this.props.product.imageArr || [];
        }
        const selectedImage = this.state.selectedImage || imageArr[0] || '';

        if( imageArr.length < 2 ) {
            return null;
        }

        return (
            <div className={ style.imageOptions }>
                { imageArr &&
                    <Carousel { ...sliderProps } >
                        { imageArr.map( ( item, index ) => {
                            return (
                                <div key={ index }>
                                    <div className={ style.imageWrapper }
                                        onClick={ () => {
                                            if( item != selectedImage ) {
                                                this.selectCarouselImage( item );
                                            } } }>
                                        <Radio
                                            className={ style.imageChecked }
                                            checked={ item == selectedImage } />
                                        <img src={ item } alt="Possible Image" />
                                    </div>
                                </div>
                            );
                        } ) }
                    </Carousel>
                }
            </div>
        );
    }
    renderImageComponent = () => {
        if( this.props.type == 'edit' || this.props.type == 'copy' ) {
            return (
                <div className={ style.cropDivEdit } >
                    <AspectRatio
                    ratio="1/1">
                        <img src={ this.state.selectedImage || this.props.product.image || '' } />
                    </AspectRatio>
                    <ImageCropModalWrapper
                    onFinish={ this.cropFinish }>
                        <div className={ style.editIconWrapper }>
                            <div>
                                <img src={ editIcon } alt="Edit Icon" />
                            </div>
                            <div className={ style.editIconText }>Edit Photo</div>
                        </div>
                    </ImageCropModalWrapper>
                </div>
            );
        }
        var formObject = this.props.formWrapper[ this.props.form ];
        var imageArr = [];
        if( this.props.product ) {
            imageArr = this.props.product.imageArr || [];
        }
        const selectedImage = this.state.selectedImage || imageArr[0] || '';
        const controlsText = imageArr.length > 0 ?
            'Position photo within cropping window or ' :
            'No images could be retrieved, please ';
        const isImageError = !!formObject && !!formObject.submitErrors && !!formObject.submitErrors.image;
        const controls = (
            <div className={ style.controls }>
                <div className={ style.uploadLink }>
                    { isImageError &&
                        <p className={ style.errorMessage }>
                            { formObject.submitErrors.image }
                        </p>
                    }
                    { controlsText }&nbsp;
                    <ImageCropModalWrapper
                    aspectRatio={ 1/1 }
                    style={ { display: 'inline-block' } }
                    onFinish={ this.cropFinish } >
                        <span>upload your own photo.</span>
                    </ImageCropModalWrapper>
                </div>
            </div>
        );

        if( this.state.usingCarousel && !!selectedImage ) {
            return (
                <div className={ style.cropDiv } >
                    <div className={ style.imageBlockWrapper }>
                        <ImageCropDiv
                        aspectRatio={ 1/1 }
                        className={ style.imageBlock }
                        src={ selectedImage }
                        childRef={ ( child ) => { this._cropWrapper = child; } } />
                    </div>
                    { this.props.screenType != 'tablet' &&
                        this.renderImageOptionsCarousel()
                    }
                    { controls }
                </div>
            );
        }
        return (
            <div className={ style.cropDiv } >
                <AspectRatio
                ratio="1/1" >
                    <img src={ this.state.selectedImage } />
                </AspectRatio>
                { this.props.screenType != 'tablet' &&
                    this.renderImageOptionsCarousel()
                }
                { controls }
            </div>
        );
    }
    renderDeleteSection = () => {
        if( this.state.deleteConfirm ) {
            return (
                <div className={style.deleteLink}>
                    <p>ARE YOU SURE YOU WANT TO DELETE THIS PRODUCT?</p>
                    <p>
                        <span className={ style.confirmDelete }
                        onClick={ this.props.deleteProduct }>
                            DELETE PRODUCT
                        </span>
                        <span className={ style.cancelDelete }
                        onClick={ this.toggleDeleteConfirmation( false ) }>
                            CANCEL
                        </span>
                    </p>
                </div>
            );
        }
        return (
            <div className={style.deleteLink}>
                <span
                onClick={ this.toggleDeleteConfirmation( true ) }>
                    DELETE THIS PRODUCT
                </span>
            </div>
        );
    }
    toggleDeleteConfirmation = ( state ) => {
        return () => {
            this.setState( { deleteConfirm: state } );
        };
    }



    render() {
        const { handleSubmit, submitting, fetching } = this.props;
        return (
            <Form className={ style.editProductDetailsForm }
            onSubmit={ handleSubmit( this.submit ) }>
                <div className={ style.upperForm }>
                    { this.renderImageComponent() }
                    <div className={ style.textDetails }>
                        <ProductFields { ...this.props } showInterests={ this.props.self.usertype != 'shopper' } />
                        <TagEditor
                        currentTags={ this.props.product ? this.props.product.tags : [] }
                        childRef={ ( el ) => { this.tagEditor = el; } }
                        style={ { marginTop: '15px'} } />
                    </div>
                </div>
                { this.props.screenType == 'tablet' &&
                    this.renderImageOptionsCarousel()
                }
                <div>
                    <div className={ style.submitButton }>
                        <PrimaryButton
                        label={ this.props.type == 'edit' ? 'Save Changes' : 'Add Product' }
                        disableTouchRipple
                        primary
                        fullWidth
                        type="submit"
                        disabled={ submitting || fetching }
                        className={ style.buttonText }
                        labelStyle={ { textTransform: 'none' } }
                        />
                        { this.props.type == 'edit' &&
                            this.renderDeleteSection()
                        }
                    </div>
                    { this.props.error &&
                        <div className={ style.errorBlock }>{ this.props.error }</div>
                    }
                </div>
            </Form>
        );
    }
}
DetailsForm.defaultProps = {
    product: {},
};

DetailsForm = reduxForm({
    form: 'DetailsForm',
})(DetailsForm);

const mapStateToProps = ( state ) => {
    return {
        self: state.self.user,
        userLists: [ ...state.self.lists ].reverse(),
        interests: state.vars.interests,
        screenType: state.screenSize.type,
        formWrapper: state.form || {},
    };
};

const mapDispatchToProps = ( dispatch ) => {
    return {
        changeFieldValue: ( field, value ) => {
            dispatch( change( 'DetailsForm', field, value ) );
        },
    };
};

export default connect( mapStateToProps, mapDispatchToProps )( DetailsForm );
